import { Component, Input, OnChanges, TemplateRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'lib-audience-ai-welcome',
    templateUrl: './audience-ai-welcome.component.html',
    styleUrl: './audience-ai-welcome.component.sass',
    standalone: false
})
export class AudienceAIWelcomeComponent implements OnChanges {
  @Input() AssistantIcon!: TemplateRef<any>;
  @Input() typingMessage!: TemplateRef<any>;
  @Input() chatInput!: TemplateRef<any>;
  @Input() errorMessage!: TemplateRef<any>;
  @Input() chatContent: string;
  @Input() hasResponseError: boolean;
  @Input() inputContext!: {
    placeholderText: string;
    audienceAIFormGroup: FormGroup;
    isQueryRunning: boolean;
    isUserInputValid: boolean;
    submitQuery: () => void;
  };

  isQueryRunning: boolean;

  welcomeCards = [
    {
      title: 'Explore my data attributes',
      description:
        'Browse and learn about the attributes in your data. Discover what each one means and view the values within to better understand what’s useful for targeting.'
    },
    {
      title: 'Start building an audience',
      description:
        "Tell us who you're trying to reach in plain language and Audience AI will guide you step-by-step to build a custom audience that matches your goals."
    }
  ];

  ngOnChanges(): void {
    this.isQueryRunning = this.inputContext?.isQueryRunning;
    this.inputContext.placeholderText =
      '“Try asking something like: ‘Create an audience of people who lives in Texas’…”';
  }
}
